import { createContext } from 'react';

import { type ShowAdsCallbackArgsType } from '@/common/types/ads';

const AdsContext = createContext(
  {} as {
    showAd: (args: ShowAdsCallbackArgsType) => Promise<void>;
    adsIsLoading: boolean;
  },
);

export { AdsContext };
